/* UFC Meal Plan Wizard — demo copy + real catalog/checkout */
(function () {
  'use strict';

  var ASSET_BASE = (document.currentScript && document.currentScript.src || '').replace(/[^/]+(?:\?.*)?$/, '');
  var TIERS = [4, 8, 12, 16];
  var PEOPLE = { me: 1, partner: 2, family: 3 };
  var MEALS_DAY = { one: 1, both: 2, all: 3 };
  var DAYS = { few: 1, three: 3, weekdays: 5, everyday: 7 };

  var GOAL_DEFS = [
    { id: 'portion', name: 'Control calories and eat smaller portions', planType: 'Cut', planKey: 'cut' },
    { id: 'maintain', name: 'Maintain my current strength levels', planType: 'Maintain', planKey: 'maintain' },
    { id: 'build', name: 'Build strength and muscle', planType: 'Build', planKey: 'build' },
    { id: 'time', name: 'Save time', planType: 'Mix & Match', planKey: 'mix' },
    { id: 'variety', name: 'Eat a wider variety of foods', planType: 'Mix & Match', planKey: 'mix' }
  ];
  var HOUSEHOLD = [
    { id: 'me', name: 'Just me' },
    { id: 'partner', name: 'Me and a partner' },
    { id: 'family', name: '3 people or more' }
  ];
  var MEALS_PER_DAY = [
    { id: 'one', name: 'One meal per day' },
    { id: 'both', name: 'Both lunch and dinner' },
    { id: 'all', name: 'All meals (3-4 per day)' }
  ];
  var DAYS_WEEK = [
    { id: 'few', name: '1-2 days' },
    { id: 'three', name: '3 days' },
    { id: 'weekdays', name: 'All 5 Weekdays' },
    { id: 'everyday', name: 'Every day of the week' }
  ];
  var PLAN_DESC = {
    Cut: 'Thoughtfully portioned, nutrient-dense meals that keep you satisfied all day long. Delivers 25-40g protein per meal.',
    Maintain: 'Balanced meals that help you maintain your current wellness goals. Delivers 30-40g protein per meal.',
    Build: 'Robust meals built to power your day and support strength goals. Delivers 40-60g protein per meal.',
    'Mix & Match': 'Get the best of all worlds! Unlock a range of choices from our Cut, Maintain, and Build plans for increased flexibility. Delivers 25-60g of protein per meal.'
  };
  var PLAN_TYPES = ['Cut', 'Maintain', 'Build', 'Mix & Match'];
  var PLAN_KEY = { Cut: 'cut', Maintain: 'maintain', Build: 'build', 'Mix & Match': 'mix' };
  var ALLERGENS = ['Wheat', 'Milk', 'Soy', 'Egg', 'Sesame', 'Peanut', 'Fish', 'Tree Nut', 'Shellfish', 'Pork'];
  var ALLERGEN_GROUPS = {
    'Tree Nut': ['Tree Nut', 'Almond', 'Cashews'],
    Fish: ['Fish', 'Salmon', 'Anchovy'],
    Shellfish: ['Shellfish', 'Shrimp']
  };
  var PROTEINS = [
    { id: 'all', name: 'All' },
    { id: 'chicken', name: 'Chicken' },
    { id: 'beef', name: 'Beef' },
    { id: 'pork', name: 'Pork' },
    { id: 'fish', name: 'Fish' },
    { id: 'shrimp', name: 'Shrimp' },
    { id: 'plant', name: 'Plant-based' }
  ];
  var STEPS = [
    { n: 1, title: 'What are your goals?', sub: "Select your main goal. We'll use those to determine the best plan for you." },
    { n: 2, title: "Who's eating?", sub: "Let us know how many people you're feeding. You can always adjust this later if things change." },
    { n: 3, title: 'How many UFC Ignite meals will you have on a daily basis?', sub: 'Choose what best supports your lifestyle now. You can always adjust this later.' },
    { n: 4, title: 'How many days a week will you have UFC Ignite meals?', sub: 'Choose what best supports your lifestyle now. You can always adjust this later.' },
    { n: 5, title: 'Our Recommendation to You', sub: "Based on your goals, here's the plan we've built for you." },
    { n: 6, title: 'Protein preference', sub: "We'll help you find meals that match your selected favorites. You can always adjust this if your preferences change. " },
    { n: 7, title: 'Choose exclusions', sub: "Tell us what you'd like to exclude so we can recommend meals that fit your needs.\n" },
    { n: 8, title: 'Sign up to receive exclusive offers', sub: "Enter your email to receive exclusive offers from UFC Ignite. This is totally optional, so you can skip this and continue." },
    { n: 9, title: 'Choose your meals', sub: 'All the meals below match your goal' },
    { n: 10, title: 'Choose your plan type', sub: 'Subscribe and save on every box, or order once with no commitment.' },
    { n: 11, title: 'Review & place your order', sub: "Here's everything before you place your order." }
  ];

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function proteinIcon(name) {
    return '<img class="mpw-protein-icon" src="' + esc(ASSET_BASE + 'ufc-protein-' + name + '.png') + '" alt="" width="26" height="26">';
  }
  function parseJson(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch (e) { return null; }
  }
  function money(cents) {
    return '$' + (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
  }
  function computeBoxSize(household, mealsPerDay, daysPerWeek) {
    var raw = (PEOPLE[household] || 1) * (MEALS_DAY[mealsPerDay] || 1) * (DAYS[daysPerWeek] || 1);
    var best = TIERS[0];
    var bestDiff = Infinity;
    for (var i = 0; i < TIERS.length; i++) {
      var t = TIERS[i];
      var d = Math.abs(t - raw);
      if (d < bestDiff || (d === bestDiff && t > best)) {
        bestDiff = d;
        best = t;
      }
    }
    return best;
  }
  function sumQty(q) {
    var n = 0;
    Object.keys(q || {}).forEach(function (k) { n += Number(q[k]) || 0; });
    return n;
  }
  function hasWord(text, kw) {
    var escKw = String(kw || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    if (!escKw) return false;
    return new RegExp('(^|[^a-z0-9])' + escKw + '([^a-z0-9]|$)', 'i').test(String(text || ''));
  }
  /* Store uses Shopify tags like "Protein: Beef" | "Protein: Poultry" (see SOP / entree-tags-infer).
     Nutrition metafield "protein" is GRAMS — never used for this filter. */
  var PROTEIN_TAG_MAP = {
    poultry: 'chicken',
    chicken: 'chicken',
    beef: 'beef',
    pork: 'pork',
    fish: 'fish',
    shrimp: 'shrimp',
    shellfish: 'shrimp',
    seafood: 'shrimp',
    vegetarian: 'plant',
    vegan: 'plant'
  };
  var PROTEIN_KW = {
    chicken: ['chicken', 'turkey', 'poultry'],
    beef: ['beef', 'steak', 'bolognese'],
    pork: ['pork'],
    fish: ['fish', 'salmon', 'tilapia', 'cod', 'tuna'],
    shrimp: ['shrimp', 'prawn'],
    plant: ['tofu', 'plant-based', 'plant based', 'vegan', 'vegetarian', 'lentil']
  };
  function proteinFromTags(tags) {
    var list = tags || [];
    for (var i = 0; i < list.length; i++) {
      var t = String(list[i] || '');
      var m = t.match(/^Protein:\s*(.+)$/i);
      if (!m) continue;
      var raw = m[1].trim().toLowerCase();
      if (PROTEIN_TAG_MAP[raw]) return PROTEIN_TAG_MAP[raw];
      // "Egg + Poultry" etc.
      if (/\bpoultry\b|\bchicken\b|\bturkey\b/.test(raw)) return 'chicken';
      if (/\bbeef\b|\bsteak\b/.test(raw)) return 'beef';
      if (/\bpork\b/.test(raw)) return 'pork';
      if (/\bfish\b|\bsalmon\b/.test(raw)) return 'fish';
      if (/\bshrimp\b|\bshellfish\b|\bseafood\b/.test(raw)) return 'shrimp';
      if (/\bvegan\b|\bvegetarian\b|\bplant\b/.test(raw)) return 'plant';
    }
    return '';
  }
  function mealCategory(m) {
    // 1) Canonical: product tag "Protein: …"
    var fromTag = proteinFromTags(m.tags);
    if (fromTag) return fromTag;
    // 2) Fallback: title keywords (same idea as classic meal-selection)
    var title = String(m.name || '').toLowerCase();
    var ids = Object.keys(PROTEIN_KW);
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      var kws = PROTEIN_KW[id];
      for (var j = 0; j < kws.length; j++) {
        if (hasWord(title, kws[j])) return id;
      }
    }
    return 'other';
  }
  function mealMatchesProteins(m, actProteins) {
    if (!actProteins || !actProteins.length) return true;
    return actProteins.indexOf(m.category) >= 0;
  }
  function allergenTagsFor(name) {
    var names = ALLERGEN_GROUPS[name] || [name];
    return names.map(function (n) { return 'Allergen: ' + n; });
  }
  function mealHasAllergen(m, allergenName) {
    if (allergenName === 'Pork') {
      if (m.category === 'pork') return true;
      var porkText = [m.name].concat(m.tags || []).join(' ');
      if (['pork', 'bacon', 'ham', 'prosciutto', 'pepperoni'].some(function (kw) { return hasWord(porkText, kw); })) return true;
    }
    var need = allergenTagsFor(allergenName);
    var tags = (m.tags || []).map(String);
    return need.some(function (t) { return tags.indexOf(t) >= 0; });
  }
  function deliveryDateLabel(now) {
    var current = now || new Date();
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      weekday: 'short'
    }).formatToParts(current);
    var pt = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') pt[part.type] = part.value;
    });
    var weekdayIndex = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[pt.weekday];
    var daysUntilCutoff = (8 - weekdayIndex) % 7;
    var delivery = new Date(Date.UTC(
      Number(pt.year),
      Number(pt.month) - 1,
      Number(pt.day) + daysUntilCutoff + 4,
      12
    ));
    return delivery.toLocaleDateString('en-US', {
      timeZone: 'UTC',
      weekday: 'long',
      month: 'short',
      day: 'numeric'
    });
  }

  /* Lucide-style inline icons */
  var ICONS = {
    portion: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="2.2"/><path d="M12 3.5V12L18 16" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    maintain: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M4 16a8 8 0 0116 0" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M12 16l3-4.2" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="16" r="1.1" fill="currentColor"/></svg>',
    build: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="2.8" y="9" width="3" height="6" rx="1" stroke="currentColor" stroke-width="2.2"/><rect x="18.2" y="9" width="3" height="6" rx="1" stroke="currentColor" stroke-width="2.2"/><path d="M5.8 12h12.4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M8.3 10v4M15.7 10v4" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    time: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="13.5" r="7.5" stroke="currentColor" stroke-width="2.2"/><path d="M12 9.5v4l2.5 1.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3h5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    variety: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M3.5 7h3c1.8 0 2.7.7 3.8 2M20.5 7h-2.8c-.9 0-1.6.3-2.3.9M3.5 17h3c1.8 0 2.7-.7 3.8-2M20.5 17h-2.8c-.9 0-1.6-.3-2.3-.9" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M17 4.3l3 2.7-3 2.7M17 14.3l3 2.7-3 2.7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    me: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="8" r="3.3" stroke="currentColor" stroke-width="2.2"/><path d="M5 20c0-4 3.2-6.5 7-6.5s7 2.5 7 6.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    partner: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="9" cy="7.5" r="2.8" stroke="currentColor" stroke-width="2.1"/><circle cx="16" cy="7.5" r="2.8" stroke="currentColor" stroke-width="2.1"/><path d="M3.5 20c0-3.3 2.5-5.5 5.5-5.5 1.3 0 2.4.4 3.3 1.1.9-.7 2-1.1 3.3-1.1 3 0 5.5 2.2 5.5 5.5" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"/></svg>',
    family: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="7" cy="7" r="2.3" stroke="currentColor" stroke-width="2"/><circle cx="17" cy="7" r="2.3" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="8.5" r="2" stroke="currentColor" stroke-width="2"/><path d="M2.5 20c0-2.8 2-4.7 4.5-4.7 1 0 1.9.3 2.6.8M21.5 20c0-2.8-2-4.7-4.5-4.7-1 0-1.9.3-2.6.8M8 20c0-2.5 1.8-4 4-4s4 1.5 4 4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    one: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4.5" stroke="currentColor" stroke-width="2.2"/><path d="M12 3v2.3M12 18.7V21M3 12h2.3M18.7 12H21M5.8 5.8l1.6 1.6M16.6 16.6l1.6 1.6M5.8 18.2l1.6-1.6M16.6 7.4l1.6-1.6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    both: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><circle cx="8" cy="12" r="4" stroke="currentColor" stroke-width="2.2"/><path d="M18.5 8.7a4.6 4.6 0 100 6.6 5.3 5.3 0 010-6.6z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg>',
    all: '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><ellipse cx="12" cy="6" rx="6" ry="2" stroke="currentColor" stroke-width="2.1"/><ellipse cx="12" cy="12" rx="6" ry="2" stroke="currentColor" stroke-width="2.1"/><ellipse cx="12" cy="18" rx="6" ry="2" stroke="currentColor" stroke-width="2.1"/></svg>',
    cal: function (n) {
      return '<svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="2" y="5.2" width="20" height="15.8" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M2 9.2h20" stroke="currentColor" stroke-width="1.6"/><path d="M7 2.5v3.4M17 2.5v3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><text x="12" y="18.5" text-anchor="middle" font-size="9" font-weight="700" fill="currentColor">' + n + '</text></svg>';
    },
    proteinAll: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><rect x="4" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="2.4"/><rect x="13" y="4" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="2.4"/><rect x="4" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="2.4"/><rect x="13" y="13" width="7" height="7" rx="1.3" stroke="currentColor" stroke-width="2.4"/></svg>',
    chicken: proteinIcon('chicken'),
    beef: proteinIcon('beef'),
    pork: proteinIcon('pork'),
    fish: proteinIcon('fish'),
    shrimp: proteinIcon('shrimp'),
    plant: proteinIcon('plant'),
    Wheat: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 22V3" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><path d="M12 6.5l-3-2M12 6.5l3-2M12 10l-3-2M12 10l3-2M12 13.5l-3-2M12 13.5l3-2M12 17l-3-2M12 17l3-2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    Milk: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M8 3h8l1.3 3.2H6.7z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/><path d="M6.7 6.2h10.6v13.5a1.3 1.3 0 01-1.3 1.3H8a1.3 1.3 0 01-1.3-1.3z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/></svg>',
    Soy: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9 4c-2.2 3-2.2 13 0 16 .9 1.2 1.9 1.7 3 1.7s2.1-.5 3-1.7c2.2-3 2.2-13 0-16-.9-1.2-1.9-1.7-3-1.7S9.9 2.8 9 4z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><circle cx="12" cy="8" r="1.4" fill="currentColor"/><circle cx="12" cy="12.3" r="1.4" fill="currentColor"/><circle cx="12" cy="16.6" r="1.4" fill="currentColor"/></svg>',
    Egg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3c4 5 6 9 6 12a6 6 0 01-12 0c0-3 2-7 6-12z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg>',
    Sesame: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><circle cx="8" cy="9" r="2.2" stroke="currentColor" stroke-width="1.8"/><circle cx="16" cy="8" r="2.2" stroke="currentColor" stroke-width="1.8"/><circle cx="7" cy="16" r="2.2" stroke="currentColor" stroke-width="1.8"/><circle cx="15.5" cy="16.5" r="2.2" stroke="currentColor" stroke-width="1.8"/></svg>',
    Peanut: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M9.5 3.5a4.3 4.3 0 000 8.6c1 0 2-.3 2.7-.9.7.6 1.7.9 2.7.9a4.3 4.3 0 000-8.6c-1 0-2 .3-2.7.9a4.2 4.2 0 00-2.7-.9z" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round" transform="rotate(90 12 12)"/></svg>',
    FishA: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M2.5 12c3-4 8-6 12-4 2 1 3.5 2.5 4.5 4-1 1.5-2.5 3-4.5 4-4 2-9 0-12-4z" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/><circle cx="7" cy="11" r="0.9" fill="currentColor"/><path d="M19 9.8l2.5-1.8M19 14.2l2.5 1.8" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    'Tree Nut': '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M12 3.2v1.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M6.2 9.8c0-3.2 2.6-5.3 5.8-5.3s5.8 2.1 5.8 5.3" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"/><path d="M6.2 9.8h11.6" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"/><ellipse cx="12" cy="15.5" rx="5.2" ry="5.3" stroke="currentColor" stroke-width="2.1"/></svg>',
    Shellfish: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M18.5 6.5c-5-3-11-1-13 4-1.4 3.4 0 7.6 3.6 9.3" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"/><path d="M16 4.5l1.5 2.5-2.8.6M7 17.5l-1 2.8 3-.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    goal: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 9v6M4 8v8M18 9v6M20 8v8M8 12h8" stroke="#fff" stroke-width="2.4" stroke-linecap="round"/></svg>'
  };

  var STORAGE_KEY = 'ufc_mpw_wizard_v1';

  function persistableState(state) {
    return {
      step: state.step,
      goal: state.goal,
      household: state.household,
      mealsPerDay: state.mealsPerDay,
      daysPerWeek: state.daysPerWeek,
      boxSize: state.boxSize,
      allergens: state.allergens || {},
      proteins: state.proteins || {},
      mealQty: state.mealQty || {},
      plan: state.plan,
      quizCompletedSteps: state.quizCompletedSteps || {},
      terms: !!state.terms,
      planTypeOverride: state.planTypeOverride,
      promoEmail: state.promoEmail || '',
      promoConsent: !!state.promoConsent,
      email30Claimed: !!state.email30Claimed,
      email30Code: String(state.email30Code || '')
    };
  }

  function saveWizardState(state) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(persistableState(state)));
    } catch (e) {}
  }

  function loadWizardState() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || typeof s !== 'object') return null;
      var step = Math.max(1, Math.min(11, parseInt(s.step, 10) || 1));
      return {
        step: step,
        goal: s.goal || null,
        household: s.household || null,
        mealsPerDay: s.mealsPerDay || null,
        daysPerWeek: s.daysPerWeek || null,
        boxSize: TIERS.indexOf(Number(s.boxSize)) >= 0 ? Number(s.boxSize) : 8,
        allergens: s.allergens && typeof s.allergens === 'object' ? s.allergens : {},
        proteins: s.proteins && typeof s.proteins === 'object' ? s.proteins : {},
        mealQty: s.mealQty && typeof s.mealQty === 'object' ? s.mealQty : {},
        plan: s.plan === 'subscribe' || s.plan === 'onetime' ? s.plan : null,
        quizCompletedSteps: s.quizCompletedSteps || {},
        terms: !!s.terms,
        planTypeOverride: s.planTypeOverride || null,
        showPlanEditor: false,
        showBoxEditor: false,
        promoEmail: String(s.promoEmail || ''),
        promoConsent: !!s.promoConsent,
        email30Claimed: !!s.email30Claimed,
        email30Code: String(s.email30Code || ''),
        promoModalOpen: false,
        promoBusy: false,
        promoError: '',
        checkoutBusy: false
      };
    } catch (e) {
      return null;
    }
  }

  function clearWizardState() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function parseShoppingPreselection() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      if (String(params.get('entry') || '').trim().toLowerCase() !== 'shopping') return null;
      var plan = String(params.get('plan') || '').trim().toLowerCase().replace(/_/g, '-');
      if (plan === 'mix-match' || plan === 'mixmatch' || plan === 'mix-and-match' || plan === 'mixandmatch') plan = 'mix';
      var planTypes = { cut: 'Cut', maintain: 'Maintain', build: 'Build', mix: 'Mix & Match' };
      var goals = { cut: 'portion', maintain: 'maintain', build: 'build', mix: 'variety' };
      var qty = parseInt(String(params.get('qty') || '').trim(), 10);
      if (!planTypes[plan] || TIERS.indexOf(qty) < 0) return null;
      return { plan: plan, planType: planTypes[plan], goal: goals[plan], qty: qty };
    } catch (e) {
      return null;
    }
  }

  /* Landing-page goal deep links: /pages/meal-plan-wizard#cut|maintain|build|mix
     (carried over by the Get Started router; classic reads the same hashes). */
  function parseHashGoal() {
    try {
      var h = String(window.location.hash || '').replace(/^#/, '').trim().toLowerCase().replace(/_/g, '-');
      if (h === 'mix-match' || h === 'mixmatch' || h === 'mix-and-match' || h === 'mixandmatch') h = 'mix';
      var goals = { cut: 'portion', maintain: 'maintain', build: 'build', mix: 'variety' };
      return goals[h] || null;
    } catch (e) {
      return null;
    }
  }

  function init() {
    var root = document.getElementById('mpw-root');
    var mount = document.getElementById('mpw-app');
    if (!root || !mount) return;
    try {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    } catch (e) {}
    var config = parseJson(document.getElementById('mpw-config')) || {};
    var GOAL_ICONS = Object.assign({}, config.goalIcons || {});
    var ALLERGEN_ICONS = Object.assign({}, config.allergenIcons || {});
    try {
      var qvModalBoot = document.getElementById('ufc-meal-qv');
      if (qvModalBoot) {
        var rawIcons = qvModalBoot.getAttribute('data-goal-icons');
        if (rawIcons) Object.assign(GOAL_ICONS, JSON.parse(rawIcons) || {});
      }
    } catch (e) {}
    var mealModalImgSeq = 0;
    var MEAL_MODAL_BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
    var mealsByGoal = {
      cut: parseJson(document.getElementById('mpw-meals-cut')) || [],
      maintain: parseJson(document.getElementById('mpw-meals-maintain')) || [],
      build: parseJson(document.getElementById('mpw-meals-build')) || [],
      mix: parseJson(document.getElementById('mpw-meals-mix')) || []
    };
    mealsByGoal.cut.forEach(function (m) { m.category = mealCategory(m); m.planGoal = 'cut'; });
    mealsByGoal.maintain.forEach(function (m) { m.category = mealCategory(m); m.planGoal = 'maintain'; });
    mealsByGoal.build.forEach(function (m) { m.category = mealCategory(m); m.planGoal = 'build'; });
    mealsByGoal.mix.forEach(function (m) { m.category = mealCategory(m); m.planGoal = 'mix'; });

    var OTHER_MEALS_INITIAL = 4;
    var REVIEW_MEALS_INITIAL = 3;
    var shoppingPreselection = parseShoppingPreselection();
    var hashGoal = shoppingPreselection ? null : parseHashGoal();
    var restored = shoppingPreselection || hashGoal ? null : loadWizardState();
    var state = restored || {
      step: 1,
      goal: null,
      household: null,
      mealsPerDay: null,
      daysPerWeek: null,
      boxSize: 8,
      allergens: {},
      proteins: {},
      mealQty: {},
      plan: null,
      terms: false,
      planTypeOverride: null,
      showPlanEditor: false,
      showBoxEditor: false,
      promoEmail: '',
      promoConsent: false,
      email30Claimed: false,
      email30Code: '',
      promoModalOpen: false,
      promoBusy: false,
      promoError: '',
      checkoutBusy: false
    };
    if (shoppingPreselection) {
      state.step = 5;
      state.goal = shoppingPreselection.goal;
      state.boxSize = shoppingPreselection.qty;
      state.planTypeOverride = shoppingPreselection.planType;
      state.household = null;
      state.mealsPerDay = null;
      state.daysPerWeek = null;
      state.allergens = {};
      state.proteins = {};
      state.mealQty = {};
      state.plan = null;
      state.terms = false;
      state.showPlanEditor = false;
      state.showBoxEditor = false;
      state.promoEmail = '';
      state.promoConsent = false;
      state.email30Claimed = false;
      state.email30Code = '';
      state.promoModalOpen = false;
      state.promoBusy = false;
      state.promoError = '';
      state.checkoutBusy = false;
      saveWizardState(state);
    } else if (hashGoal) {
      state.goal = hashGoal;
      state.step = 2;
      saveWizardState(state);
    }
    var promoReturnFocus = false;
    var subscribedEmails = new Set();
    state.otherMealsExpanded = false;
    state.reviewMealsExpanded = false;

    var editor = null;
    var selectionNotice = '';
    var lastViewedStep = null;
    var completedSteps = state.quizCompletedSteps || {};
    state.quizCompletedSteps = completedSteps;
    var STEP_KEYS = ['goal', 'household', 'meals_per_day', 'days_per_week', 'recommendation', 'protein', 'exclusions', 'email', 'meals', 'purchase_mode', 'review'];
    var pendingQuizEvents = [];
    var quizPublishTimer = null;
    var quizPublishAttempts = 0;

    function flushQuizEvents() {
      quizPublishTimer = null;
      var analytics = window.Shopify && window.Shopify.analytics;
      if (!analytics || typeof analytics.publish !== 'function') {
        if (pendingQuizEvents.length && quizPublishAttempts < 50) {
          quizPublishAttempts += 1;
          quizPublishTimer = window.setTimeout(flushQuizEvents, 100);
        } else {
          pendingQuizEvents = [];
        }
        return;
      }
      quizPublishAttempts = 0;
      var events = pendingQuizEvents;
      pendingQuizEvents = [];
      events.forEach(function (event) {
        try {
          var result = analytics.publish(event.name, event.data);
          if (result && typeof result.catch === 'function') result.catch(function () {});
        } catch (e) {}
      });
    }

    function trackQuiz(name, details) {
      try {
        var context = window.UFCGetStartedExperiment && window.UFCGetStartedExperiment.context || {};
        var params = Object.assign({}, context, {
          quiz_version: 'meal_wizard_v1',
          step_number: state.step, step_name: STEP_KEYS[state.step - 1],
          plan_type: planKey(), box_qty: state.boxSize,
          protein_preference: activeProteins().join(',') || 'all',
          purchase_mode: state.plan || 'unselected'
        }, details || {});
        if (context.experiment_assignment_source === 'qa_override') params.debug_mode = true;
        if (pendingQuizEvents.length < 100) pendingQuizEvents.push({ name: 'ufc:' + name, data: params });
        if (quizPublishTimer === null) flushQuizEvents();
      } catch (e) {}
    }
    function completeStep(outcome) {
      if (completedSteps[state.step]) return;
      completedSteps[state.step] = true;
      saveWizardState(state);
      trackQuiz('quiz_step_completed', { outcome: outcome || 'continue' });
    }
    function proteinLabel(proteins) {
      return PROTEINS.filter(function (p) { return proteins[p.id]; }).map(function (p) { return p.name; }).join(', ') || 'All';
    }
    function openEditor(kind) {
      editor = { kind: kind, plan: effectivePlanType(), box: state.boxSize, proteins: Object.assign({}, state.proteins) };
      render();
      var first = mount.querySelector('[data-editor-choice]');
      if (first) first.focus();
    }
    function closeEditor() {
      var kind = editor && editor.kind;
      editor = null;
      render();
      var trigger = mount.querySelector('[data-change="' + kind + '"]');
      if (trigger) trigger.focus();
    }
    function applyEditor() {
      var changed = editor.plan !== effectivePlanType() || editor.box !== state.boxSize || proteinLabel(editor.proteins) !== proteinLabel(state.proteins);
      if (changed) {
        var previousQty = sumQty(state.mealQty);
        state.planTypeOverride = editor.plan;
        state.boxSize = editor.box;
        state.proteins = Object.assign({}, editor.proteins);
        var allowed = {};
        filteredMeals().forEach(function (m) { allowed[m.id] = true; });
        var nextQty = {};
        Object.keys(state.mealQty).forEach(function (id) { if (allowed[id]) nextQty[id] = state.mealQty[id]; });
        state.mealQty = nextQty;
        state.terms = false;
        state.otherMealsExpanded = false;
        selectionNotice = previousQty ? 'Your choices were updated. Compatible meals were kept. Please review your meals and select exactly ' + state.boxSize + ' before continuing.' : '';
        if (previousQty && state.step >= 9) state.step = 9;
        trackQuiz('quiz_selection_edited', { edited_field: editor.kind });
        saveWizardState(state);
      }
      closeEditor();
    }
    function editorHtml() {
      if (!editor) return '';
      var options = editor.kind === 'plan' ? PLAN_TYPES : editor.kind === 'box' ? TIERS : PROTEINS;
      var html = '<section class="mpw-choice-editor" aria-label="Edit ' + esc(editor.kind) + '"><div class="edit-chip-row">';
      options.forEach(function (option) {
        var value = editor.kind === 'protein' ? option.id : option;
        var label = editor.kind === 'protein' ? option.name : editor.kind === 'box' ? option + ' meals' : option;
        var selected = editor.kind === 'protein' ? (value === 'all' ? !Object.keys(editor.proteins).length : !!editor.proteins[value]) : editor[editor.kind] === value;
        html += '<button type="button" class="pill-btn ' + (selected ? 'sel' : '') + '" aria-pressed="' + selected + '" data-editor-choice="' + esc(value) + '">' + esc(label) + '</button>';
      });
      return html + '</div><div class="inline-nav"><button type="button" class="back-btn" data-editor-action="cancel">Cancel</button><button type="button" class="continue-btn" data-editor-action="save">Save changes</button></div></section>';
    }

    function effectivePlanType() {
      if (state.planTypeOverride) return state.planTypeOverride;
      var g = GOAL_DEFS.find(function (x) { return x.id === state.goal; });
      return g ? g.planType : 'Maintain';
    }
    function hasSavedPromoEmail() {
      var email = String(state.promoEmail || '').trim();
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    function planKey() {
      return PLAN_KEY[effectivePlanType()] || 'maintain';
    }
    function catalogForPlan() {
      var key = planKey();
      if (key !== 'mix') return mealsByGoal[key] || [];
      if (config.mixListSource === 'collection') return mealsByGoal.mix || [];
      var seen = {};
      var out = [];
      ['cut', 'maintain', 'build'].forEach(function (g) {
        (mealsByGoal[g] || []).forEach(function (m) {
          if (seen[m.id]) return;
          seen[m.id] = true;
          out.push(m);
        });
      });
      (mealsByGoal.mix || []).forEach(function (m) {
        if (seen[m.id]) return;
        seen[m.id] = true;
        out.push(m);
      });
      return out;
    }
    function filteredMeals() {
      return catalogForPlan().filter(function (m) {
        for (var a in state.allergens) {
          if (state.allergens[a] && mealHasAllergen(m, a)) return false;
        }
        return true;
      });
    }
    function activeProteins() {
      return Object.keys(state.proteins).filter(function (k) { return state.proteins[k]; });
    }
    function boxPriceCents() {
      var p = (config.prices && config.prices[planKey()]) || {};
      return Number(p[String(state.boxSize)]) || 0;
    }
    function variantId() {
      var v = (config.variants && config.variants[planKey()]) || {};
      return String(v[String(state.boxSize)] || '').replace(/\D/g, '');
    }
    function sellingPlanId() {
      var sp = (config.sellingPlans && config.sellingPlans[String(state.boxSize)]) || '';
      return String(sp || '').replace(/\D/g, '');
    }

    function setState(patch) {
      Object.keys(patch).forEach(function (k) { state[k] = patch[k]; });
      saveWizardState(state);
      render();
    }

    function setStatePreservingScroll(patch) {
      var scrollX = window.scrollX || 0;
      var scrollY = window.scrollY || 0;
      setState(patch);
      requestAnimationFrame(function () {
        if (Math.abs((window.scrollY || 0) - scrollY) < 2) return;
        window.scrollTo(scrollX, scrollY);
      });
    }

    function advanceStep() {
      completeStep();
      if (state.step === 9) selectionNotice = '';
      var next = Math.min(11, state.step + 1);
      setStatePreservingScroll({ step: next });
    }

    async function subscribePromoEmail(email) {
      var klaviyo = config.klaviyo || {};
      if (!klaviyo.companyId || !klaviyo.listId) throw new Error('newsletter_not_configured');
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 10000);
      try {
        var response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(klaviyo.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          signal: controller.signal,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'UFC Ignite Meal Plan Quiz',
                profile: { data: { type: 'profile', attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                } } }
              },
              relationships: { list: { data: { type: 'list', id: klaviyo.listId } } }
            }
          })
        });
        if (!response.ok) throw new Error('newsletter_subscription_failed');
        if (window.UFCAnalytics && !window.__ufcQuizSignupPublished) {
          window.__ufcQuizSignupPublished = true;
          window.UFCAnalytics.publish('klaviyo', { source: 'meal_plan_quiz' });
        }
      } finally {
        clearTimeout(timeout);
      }
    }

    async function goNext() {
      if (editor || state.promoBusy) return;
      if ((state.step === 9 && sumQty(state.mealQty) !== state.boxSize) || (state.step === 10 && !state.plan)) {
        trackQuiz('quiz_validation_failed', { reason: state.step === 9 ? 'meal_count' : 'purchase_mode' });
        return;
      }
      if (state.step === 8) {
        var email = String(state.promoEmail || '').trim();
        if (email || state.promoConsent) {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            trackQuiz('quiz_validation_failed', { reason: 'email_format' });
            state.promoError = 'Enter a valid email address.';
            render();
            return;
          }
          if (!state.promoConsent) {
            trackQuiz('quiz_validation_failed', { reason: 'email_consent' });
            state.promoError = 'Please accept the email consent checkbox, or choose Skip.';
            render();
            return;
          }
          var emailKey = email.toLowerCase();
          if (!subscribedEmails.has(emailKey)) {
            setState({ promoBusy: true, promoError: '' });
            try {
              await subscribePromoEmail(email);
              subscribedEmails.add(emailKey);
            } catch (e) {
              setState({ promoBusy: false, promoError: 'We could not submit your signup. Please try again, or choose Skip to continue.' });
              return;
            }
            state.promoBusy = false;
          }
          state.email30Claimed = false;
          state.email30Code = '';
          state.promoError = '';
          saveWizardState(state);
        } else {
          state.email30Claimed = false;
          state.email30Code = '';
          state.promoError = '';
        }
      }
      advanceStep();
    }
    function goBack() {
      if (editor) { closeEditor(); return; }
      var previousStep = shoppingPreselection && state.step === 5 ? 1 : Math.max(1, state.step - 1);
      setStatePreservingScroll({ step: previousStep, showPlanEditor: false, showBoxEditor: false });
    }

    function optCard(sel, iconHtml, name, idAttr) {
      return '<button type="button" class="opt-card ' + (sel ? 'sel' : '') + '" data-opt="' + esc(idAttr) + '"><div class="opt-top"><div class="fx ac gap12"><div class="img-slot img-slot-card">' + iconHtml + '</div><div class="opt-name">' + esc(name) + '</div></div><div class="radio ' + (sel ? 'sel' : '') + '"></div></div></button>';
    }

    function mealGoalKey(m) {
      var g = String(m.goal || m.planGoal || '').toLowerCase();
      if (g === 'cut' || g === 'maintain' || g === 'build' || g === 'mix') return g;
      var tags = m.tags || [];
      for (var i = 0; i < tags.length; i++) {
        var tl = String(tags[i] || '').toLowerCase();
        if (tl.indexOf('cut') >= 0) return 'cut';
        if (tl.indexOf('maintain') >= 0) return 'maintain';
        if (tl.indexOf('build') >= 0) return 'build';
        if (tl.indexOf('mix') >= 0) return 'mix';
      }
      return planKey();
    }

    var GOAL_LABEL = { cut: 'CUT', maintain: 'MAINTAIN', build: 'BUILD', mix: 'MIX' };

    function goalBadgeHtml(m) {
      var key = mealGoalKey(m);
      var src = GOAL_ICONS[key] || GOAL_ICONS.mix || GOAL_ICONS.cut || '';
      var icon = src ? '<img src="' + esc(src) + '" alt="" width="20" height="20" loading="lazy">' : '';
      return '<span class="goal-badge">' + icon + '<span class="goal-badge__text">' + (GOAL_LABEL[key] || 'MIX') + '</span></span>';
    }

    function normalizeImgUrl(url) {
      var src = String(url || '').trim();
      if (!src) return '';
      if (src.indexOf('//') === 0) return 'https:' + src;
      if (src.indexOf('http://') === 0) return 'https://' + src.slice(7);
      return src;
    }

    function renderMealCard(m, i, totalQty) {
      var qty = state.mealQty[m.id] || state.mealQty[String(m.id)] || 0;
      var disabled = totalQty >= state.boxSize && qty === 0;
      var media = m.img
        ? '<img class="meal-img" src="' + esc(m.img) + '" alt="' + esc(m.name) + '" loading="lazy" decoding="async">'
        : '<div class="meal-img meal-img--placeholder" aria-hidden="true"></div>';
      var action = qty > 0
        ? '<div class="stepper"><button type="button" class="stepper-btn" data-rm="' + m.id + '">−</button><span class="stepper-qty">' + qty + '</span><button type="button" class="stepper-btn" data-add="' + m.id + '"' + (totalQty >= state.boxSize ? ' disabled' : '') + '>+</button></div>'
        : '<button type="button" class="addbtn" data-add="' + m.id + '"' + (disabled ? ' disabled' : '') + '>+ Add to Cart</button>';
      return '<div class="meal-card" data-meal-id="' + m.id + '"><button type="button" class="plate mpw-meal-open" data-open="' + m.id + '">' + goalBadgeHtml(m) + media + '</button><div class="meal-name">' + esc(m.name) + '</div><div class="macro-row"><div class="macro"><span class="macro-k">Cal</span><span class="macro-v">' + esc(m.cal || '—') + '</span></div><div class="macro"><span class="macro-k">Carbs</span><span class="macro-v">' + esc(m.carbs || '—') + (m.carbs !== '' && m.carbs != null ? 'g' : '') + '</span></div><div class="macro"><span class="macro-k">Fat</span><span class="macro-v">' + esc(m.fat || '—') + (m.fat !== '' && m.fat != null ? 'g' : '') + '</span></div><div class="macro"><span class="macro-k">Protein</span><span class="macro-v">' + esc(m.protein || '—') + (m.protein !== '' && m.protein != null ? 'g' : '') + '</span></div></div>' + action + '</div>';
    }

    function openQuickview(m) {
      var modal = document.getElementById('ufc-meal-qv');
      if (!modal || !m) return;
      var gKey = mealGoalKey(m);
      if (gKey !== 'cut' && gKey !== 'maintain' && gKey !== 'build') gKey = 'mix';

      var setNut = function (sel, val, suffix) {
        var el = modal.querySelector(sel);
        if (!el) return;
        if (val != null && String(val).trim() !== '') el.textContent = String(val) + (suffix || '');
        else el.textContent = '—';
      };

      var titleEl = modal.querySelector('[data-mdl-title]');
      if (titleEl) titleEl.textContent = m.name || '';

      var goalPill = modal.querySelector('[data-mdl-goal]');
      var goalText = modal.querySelector('[data-mdl-goal-text]');
      var goalIconEl = modal.querySelector('[data-mdl-goal-icon]');
      if (goalPill) {
        if (goalText) goalText.textContent = GOAL_LABEL[gKey] || 'MIX';
        if (goalIconEl) {
          var iconSrc = GOAL_ICONS[gKey] || GOAL_ICONS.mix || '';
          if (iconSrc) {
            goalIconEl.src = iconSrc;
            goalIconEl.alt = '';
            goalIconEl.hidden = false;
            goalIconEl.removeAttribute('hidden');
          } else {
            goalIconEl.removeAttribute('src');
            goalIconEl.hidden = true;
          }
        }
        goalPill.removeAttribute('hidden');
        goalPill.hidden = false;
      }

      setNut('[data-mdl-cal]', m.cal, '');
      setNut('[data-mdl-carbs]', m.carbs, 'g');
      setNut('[data-mdl-fat]', m.fat, 'g');
      setNut('[data-mdl-protein]', m.protein, 'g');

      var bullets = modal.querySelector('[data-mdl-bullets]');
      if (bullets) {
        bullets.innerHTML = '';
        var arr = Array.isArray(m.bullets) ? m.bullets : [];
        if (arr.length) {
          arr.forEach(function (text) {
            var li = document.createElement('li');
            li.textContent = text;
            bullets.appendChild(li);
          });
          bullets.removeAttribute('hidden');
        } else {
          bullets.setAttribute('hidden', '');
        }
      }

      var detail = modal.querySelector('[data-mdl-detail]');
      if (detail) {
        detail.href = m.url || '#';
        detail.onclick = function () { saveWizardState(state); };
      }
      var add = modal.querySelector('[data-mdl-add]');
      if (add) {
        add.href = '#';
        add.onclick = function (e) {
          e.preventDefault();
          addMeal(m.id);
          closeQuickview();
        };
      }

      var img = modal.querySelector('.mb-meal-detail-modal__img');
      if (img) {
        img.onload = null;
        img.onerror = null;
        var imgSeq = ++mealModalImgSeq;
        img.classList.add('is-pending');
        img.hidden = false;
        img.src = MEAL_MODAL_BLANK_IMG;
        function revealIfCurrent() {
          if (imgSeq !== mealModalImgSeq) return;
          img.classList.remove('is-pending');
        }
        function bindAndDecode() {
          if (imgSeq !== mealModalImgSeq) return;
          var src = normalizeImgUrl(m.img);
          if (!src) {
            img.removeAttribute('src');
            img.alt = '';
            img.hidden = true;
            img.classList.remove('is-pending');
            return;
          }
          img.alt = m.name || '';
          img.loading = 'eager';
          try { img.fetchPriority = 'high'; } catch (e2) {}
          img.src = src;
          function afterDecode() {
            if (imgSeq !== mealModalImgSeq) return;
            requestAnimationFrame(function () {
              if (imgSeq !== mealModalImgSeq) return;
              revealIfCurrent();
            });
          }
          if (typeof img.decode === 'function') {
            img.decode().then(afterDecode, afterDecode);
          } else {
            img.onload = afterDecode;
            img.onerror = afterDecode;
            if (img.complete && img.naturalWidth > 0) afterDecode();
          }
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(bindAndDecode);
        });
      }

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mb-meal-modal-lock');
      try {
        var xBtn = modal.querySelector('.mb-meal-detail-modal__x');
        if (xBtn) xBtn.focus();
      } catch (e3) {}
    }

    function closeQuickview() {
      var modal = document.getElementById('ufc-meal-qv');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('mb-meal-modal-lock');
      mealModalImgSeq++;
      var img = modal.querySelector('.mb-meal-detail-modal__img');
      if (img) {
        img.onload = null;
        img.onerror = null;
        img.classList.add('is-pending');
        img.src = MEAL_MODAL_BLANK_IMG;
      }
    }

    function addMeal(id) {
      if (sumQty(state.mealQty) >= state.boxSize) return;
      var q = Object.assign({}, state.mealQty);
      q[id] = (q[id] || 0) + 1;
      setState({ mealQty: q });
    }
    function removeMeal(id) {
      var q = Object.assign({}, state.mealQty);
      if (!q[id]) return;
      q[id] -= 1;
      if (q[id] <= 0) delete q[id];
      setState({ mealQty: q });
    }
    function smartSelect() {
      var all = filteredMeals();
      var act = activeProteins();
      var preferred = act.length ? all.filter(function (m) { return mealMatchesProteins(m, act); }) : all;
      var list = preferred.length ? preferred : all;
      if (!list.length) return;
      var q = Object.assign({}, state.mealQty);
      var total = sumQty(q);
      if (total >= state.boxSize) return;
      var i = 0;
      while (total < state.boxSize) {
        var m = list[i % list.length];
        q[m.id] = (q[m.id] || 0) + 1;
        total++;
        i++;
      }
      setState({ mealQty: q });
    }

    async function claimEmail30() {
      var email = String(state.promoEmail || '').trim();
      if (!email || !state.promoConsent) return null;
      var urls = config.email30Api || ['/api/email-30-discount'];
      var lastErr = null;
      for (var i = 0; i < urls.length; i++) {
        try {
          var res = await fetch(urls[i], {
            method: 'POST',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ email: email, marketingConsent: true })
          });
          var json = await res.json().catch(function () { return {}; });
          if (res.ok && (json.discountCode || json.code)) {
            state.email30LastError = '';
            return json.discountCode || json.code;
          }
          lastErr = json.error || ('HTTP ' + res.status);
        } catch (e) {
          lastErr = e.message || 'network';
        }
      }
      state.email30LastError = String(lastErr || 'unknown');
      console.warn('[mpw] email30 claim failed', lastErr);
      return null;
    }

    async function clearCartAndWait() {
      var clearRes = await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!clearRes.ok) throw new Error('cart_clear_failed_' + clearRes.status);

      // Shopify cart attributes may survive cart/clear.js and checkout cloning.
      // Remove IFW markers before a normal meal-plan checkout is created.
      try {
        var attrRes = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              _order_type: '',
              one_time_order: '',
              IFW_special: '',
              _ifw_special: '',
              order_tag: '',
              tags: ''
            }
          })
        });
        if (!attrRes.ok) console.warn('[mpw] IFW cart attribute cleanup failed', attrRes.status);
      } catch (attrErr) {
        console.warn('[mpw] IFW cart attribute cleanup failed', attrErr);
      }

      for (var attempt = 0; attempt < 10; attempt++) {
        var cartRes = await fetch('/cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!cartRes.ok) throw new Error('cart_check_failed_' + cartRes.status);
        var cart = await cartRes.json();
        if (!cart || Number(cart.item_count || 0) === 0) return;
        await new Promise(function (resolve) { setTimeout(resolve, 200 + attempt * 100); });
      }
      throw new Error('cart_clear_timeout');
    }

    function addBundleToCart(cartItem) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [cartItem] })
      });
    }

    async function goCheckout() {
      if (state.checkoutBusy) return;
      if (editor) return;
      if (!state.plan || sumQty(state.mealQty) !== state.boxSize || (state.plan === 'subscribe' && (!state.terms || !sellingPlanId()))) {
        trackQuiz('quiz_validation_failed', { reason: 'checkout_selection' });
        return;
      }
      var vid = variantId();
      if (!vid) {
        trackQuiz('quiz_validation_failed', { reason: 'bundle_configuration' });
        alert('Bundle variant is not configured. Please contact support.');
        return;
      }
      var counts = state.mealQty;
      var catalog = catalogForPlan();
      var byId = {};
      catalog.forEach(function (m) { byId[m.id] = m; });
      var selectionText = '';
      var selectedVariants = {};
      Object.keys(counts).forEach(function (pid) {
        var qty = Number(counts[pid]) || 0;
        if (qty <= 0) return;
        var m = byId[pid];
        if (!m) return;
        if (selectionText) selectionText += ', ';
        selectionText += m.name + ' × ' + qty;
        if (m.variantId) selectedVariants[m.variantId] = (selectedVariants[m.variantId] || 0) + qty;
      });
      var avoid = ALLERGENS.filter(function (a) { return state.allergens[a]; });
      var properties = {
        _order_type: state.plan === 'onetime' ? 'one-time' : 'subscription',
        _get_started_ab: window.__UFC_GS_AB_VARIANT || 'wizard',
        plan_type: effectivePlanType()
      };
      if (selectionText) properties['Selected meals'] = selectionText;
      if (Object.keys(selectedVariants).length) properties._selected_variants = JSON.stringify(selectedVariants);
      if (avoid.length) properties.exclusions = avoid.join(', ');

      var cartItem = { id: parseInt(vid, 10), quantity: 1, properties: properties };
      if (state.plan === 'subscribe') {
        var planNum = parseInt(sellingPlanId(), 10);
        if (planNum) cartItem.selling_plan = planNum;
      }

      state.checkoutBusy = true;
      render();
      try {
        await clearCartAndWait();
        var addRes = await addBundleToCart(cartItem);
        var errBody = addRes.ok ? '' : await addRes.text();
        if (!addRes.ok && addRes.status === 422 && /multiple subscriptions/i.test(errBody)) {
          await clearCartAndWait();
          addRes = await addBundleToCart(cartItem);
          errBody = addRes.ok ? '' : await addRes.text();
        }
        if (!addRes.ok) {
          throw new Error(errBody.slice(0, 200) || 'cart_add_failed');
        }
        /* email-30 claim disabled while the App Proxy route is missing —
           never block checkout on it. If a code is somehow already in state,
           it still gets attached below. */
        var code = String(state.email30Code || '') || null;
        var email30Claim = code ? JSON.stringify({
          email: String(state.promoEmail || '').trim().toLowerCase(),
          code: String(code).trim().toUpperCase()
        }) : '';
        var cartUpdateRes = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _ufc_email30_claim: email30Claim } })
        });
        if (!cartUpdateRes.ok) {
          throw new Error('cart_email30_claim_failed');
        }
        if (window.UFCGetStartedExperiment && typeof window.UFCGetStartedExperiment.track === 'function') {
          window.UFCGetStartedExperiment.track('get_started_begin_checkout', {
            plan_type: planKey(),
            box_qty: String(state.boxSize),
            purchase_mode: state.plan === 'onetime' ? 'one-time' : 'subscription'
          });
        }
        completeStep('checkout');
        trackQuiz('quiz_checkout_handoff');
        clearWizardState();
        window.setTimeout(function () { window.location.href = '/checkout'; }, 900);
      } catch (e) {
        trackQuiz('quiz_validation_failed', { reason: 'checkout_request' });
        console.error('[mpw] checkout', e);
        alert('Could not start checkout. Please try again.');
        state.checkoutBusy = false;
        render();
      }
    }

    function bind() {
      mount.onclick = function (e) {
        if (e.target.closest('a.mpw-govx-verify')) return;
        var t = e.target.closest('[data-opt],[data-nav],[data-add],[data-rm],[data-open],[data-pill],[data-box],[data-prot],[data-all],[data-plan],[data-toggle],[data-change],[data-editor-choice],[data-editor-action]');
        if (!t || t.disabled || state.checkoutBusy || state.promoBusy) return;
        if (t.hasAttribute('data-editor-action')) {
          if (t.getAttribute('data-editor-action') === 'save') applyEditor(); else closeEditor();
          return;
        }
        if (t.hasAttribute('data-editor-choice') && editor) {
          var choice = t.getAttribute('data-editor-choice');
          if (editor.kind === 'protein') {
            if (choice === 'all') editor.proteins = {};
            else if (editor.proteins[choice]) delete editor.proteins[choice];
            else editor.proteins[choice] = true;
          } else editor[editor.kind] = editor.kind === 'box' ? Number(choice) : choice;
          render();
          var selected = mount.querySelector('[data-editor-choice="' + choice + '"]');
          if (selected) selected.focus();
          return;
        }
        if (t.hasAttribute('data-change')) { openEditor(t.getAttribute('data-change')); return; }
        if (editor) {
          if (t.getAttribute('data-nav') === 'back') closeEditor();
          return;
        }
        if (t.hasAttribute('data-opt')) {
          var id = t.getAttribute('data-opt');
          if (state.step === 1) {
            setState({ goal: id, planTypeOverride: null });
            goNext();
          } else if (state.step === 2) {
            setState({ household: id, boxSize: computeBoxSize(id, state.mealsPerDay, state.daysPerWeek), mealQty: {} });
            goNext();
          } else if (state.step === 3) {
            setState({ mealsPerDay: id, boxSize: computeBoxSize(state.household, id, state.daysPerWeek), mealQty: {} });
            goNext();
          } else if (state.step === 4) {
            setState({ daysPerWeek: id, boxSize: computeBoxSize(state.household, state.mealsPerDay, id), mealQty: {} });
            goNext();
          }
          return;
        }
        if (t.getAttribute('data-nav') === 'promo-confirm') {
          state.promoModalOpen = false;
          advanceStep();
          return;
        }
        if (t.getAttribute('data-nav') === 'next') { goNext(); return; }
        if (t.getAttribute('data-nav') === 'back') { goBack(); return; }
        if (t.getAttribute('data-nav') === 'skip8') {
          completeStep('skipped');
          setStatePreservingScroll({ promoEmail: '', promoConsent: false, email30Claimed: false, email30Code: '', promoError: '', step: 9 });
          return;
        }
        if (t.getAttribute('data-nav') === 'checkout') { goCheckout(); return; }
        if (t.hasAttribute('data-add')) { addMeal(t.getAttribute('data-add')); return; }
        if (t.hasAttribute('data-rm')) { removeMeal(t.getAttribute('data-rm')); return; }
        if (t.hasAttribute('data-open')) {
          var mid = t.getAttribute('data-open');
          var meal = catalogForPlan().find(function (m) { return String(m.id) === String(mid); });
          openQuickview(meal);
          return;
        }
        if (t.hasAttribute('data-prot')) {
          var pid = t.getAttribute('data-prot');
          if (pid === 'all') { setState({ proteins: {}, mealQty: {}, otherMealsExpanded: false }); return; }
          var p = Object.assign({}, state.proteins);
          if (p[pid]) delete p[pid]; else p[pid] = true;
          setState({ proteins: p, mealQty: {}, otherMealsExpanded: false });
          return;
        }
        if (t.hasAttribute('data-all')) {
          var an = t.getAttribute('data-all');
          var al = Object.assign({}, state.allergens);
          al[an] = !al[an];
          setState({ allergens: al, mealQty: {}, otherMealsExpanded: false });
          return;
        }
        if (t.getAttribute('data-plan') === 'subscribe' || t.getAttribute('data-plan') === 'onetime') {
          setState({ plan: t.getAttribute('data-plan') });
          return;
        }
        if (t.getAttribute('data-toggle') === 'consent') {
          setState({ promoConsent: !state.promoConsent, email30Claimed: false, email30Code: '', promoError: '' });
          return;
        }
        if (t.getAttribute('data-toggle') === 'terms') {
          setState({ terms: !state.terms });
          return;
        }
        if (t.getAttribute('data-toggle') === 'smart') { smartSelect(); return; }
        if (t.getAttribute('data-toggle') === 'clear') { setState({ mealQty: {} }); return; }
        if (t.getAttribute('data-toggle') === 'load-other') {
          setState({ otherMealsExpanded: true });
          return;
        }
        if (t.getAttribute('data-toggle') === 'load-review') {
          setState({ reviewMealsExpanded: true });
          return;
        }
      };
      mount.oninput = function (e) {
        if (e.target && e.target.classList.contains('promo-input')) {
          state.promoEmail = e.target.value;
          state.email30Claimed = false;
          state.email30Code = '';
          state.promoError = '';
          saveWizardState(state);
        }
      };
      mount.onkeydown = function (e) {
        if (editor && e.key === 'Escape') { e.preventDefault(); closeEditor(); return; }
        if (!state.promoModalOpen) return;
        var dialog = mount.querySelector('.mpw-email-modal__dialog');
        if (!dialog) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          state.promoModalOpen = false;
          promoReturnFocus = true;
          saveWizardState(state);
          render();
          return;
        }
        if (e.key !== 'Tab') return;
        var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([disabled]),[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])'));
        if (!focusable.length) {
          e.preventDefault();
          dialog.focus();
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      };
    }

    function render() {
      var step = state.step;
      if (lastViewedStep !== step) {
        lastViewedStep = step;
        trackQuiz('quiz_step_viewed');
        if (step === 5) trackQuiz('quiz_recommendation_viewed');
      }
      var def = STEPS[step - 1];
      var wide = step === 9 ? ' wide' : '';
      var noFixed = (step === 5 || step === 6 || step === 7 || step === 8) ? ' no-fixed-nav' : '';
      var pct = Math.round((step / 11) * 100);
      var html = '';
      html += '<div class="app' + noFixed + '">';
      html += '<div class="progress-wrap' + wide + '"><div class="progress-track"><div class="progress-fill" style="width:' + pct + '%"></div></div>';
      html += '<div class="badge-row">';
      if (step >= 2 && step <= 11 && step !== 5) html += '<button type="button" class="plan-type-badge" data-change="plan" aria-label="Edit meal plan">Plan: <b>' + esc(effectivePlanType()) + '</b> · Edit</button>';
      if (step >= 5 && step <= 11 && step !== 5) html += '<button type="button" class="plan-type-badge" data-change="box" aria-label="Edit box quantity">Box: <b>' + state.boxSize + ' meals/wk</b> · Edit</button>';
      if (step >= 7 && step <= 11 && step !== 5) {
        var actP = activeProteins();
        html += '<button type="button" class="plan-type-badge" data-change="protein" aria-label="Edit protein preferences">Protein: <b>' + esc(proteinLabel(state.proteins)) + '</b> · Edit</button>';
      }
      html += '</div></div><main class="stage' + wide + '">';

      if (step !== 5) html += editorHtml();
      if (selectionNotice) html += '<p class="mpw-selection-notice" role="status">' + esc(selectionNotice) + '</p>';

      if (step === 1) {
        html += '<div class="step-head"><div class="num-badge">1</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="opt-grid">';
        GOAL_DEFS.forEach(function (g) {
          html += optCard(state.goal === g.id, ICONS[g.id] || ICONS.portion, g.name, g.id);
        });
        html += '</div><div class="desc-bar">UFC Ignite was created by performance nutrition experts to make eating for your goals easier.</div>';
      } else if (step === 2) {
        html += '<div class="step-head"><div class="num-badge">2</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="opt-grid">';
        HOUSEHOLD.forEach(function (h) { html += optCard(state.household === h.id, ICONS[h.id], h.name, h.id); });
        html += '</div><div class="desc-bar">UFC Ignite meals come pre-portioned, individual servings.</div>';
      } else if (step === 3) {
        html += '<div class="step-head"><div class="num-badge">3</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="opt-grid">';
        MEALS_PER_DAY.forEach(function (m) { html += optCard(state.mealsPerDay === m.id, ICONS[m.id], m.name, m.id); });
        html += '</div><div class="desc-bar">With 60+ weekly options for breakfast, lunch, and dinner, there’s always something new to try.</div>';
      } else if (step === 4) {
        html += '<div class="step-head"><div class="num-badge">4</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="opt-grid">';
        var dayIcon = { few: 1, three: 3, weekdays: 5, everyday: 7 };
        DAYS_WEEK.forEach(function (d) { html += optCard(state.daysPerWeek === d.id, ICONS.cal(dayIcon[d.id]), d.name, d.id); });
        html += '</div>';
      } else if (step === 5) {
        html += '<div class="step-head"><div class="num-badge">5</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="reco-split">';
        ['plan', 'box', 'protein'].forEach(function (kind) {
          var label = kind === 'plan' ? 'Your Plan' : kind === 'box' ? 'Your Box' : 'Protein preferences';
          var value = kind === 'plan' ? effectivePlanType() + ' Plan' : kind === 'box' ? state.boxSize + ' meals / week' : proteinLabel(state.proteins);
          html += '<div class="reco-card"><div class="reco-row-head"><div class="reco-eyebrow">' + label + '</div><button type="button" class="change-btn" data-change="' + kind + '" aria-label="Edit ' + label + '" aria-expanded="' + !!(editor && editor.kind === kind) + '">Change</button></div><h2 class="hd reco-title">' + esc(value) + '</h2>';
          if (kind === 'plan') html += '<p class="reco-desc">' + esc(PLAN_DESC[effectivePlanType()] || '') + '</p>';
          if (editor && editor.kind === kind) html += editorHtml();
          html += '</div>';
        });
        html += '</div><div class="inline-nav"><button type="button" class="back-btn" data-nav="back">← Back</button><button type="button" class="continue-btn" data-nav="next"' + (editor ? ' disabled' : '') + '>Continue</button></div>';
      } else if (step === 6) {
        var act = activeProteins();
        html += '<div class="step-head"><div class="num-badge">6</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="chip-row">';
        PROTEINS.forEach(function (p) {
          var sel = p.id === 'all' ? act.length === 0 : !!state.proteins[p.id];
          var ic = p.id === 'all' ? ICONS.proteinAll : (ICONS[p.id] || ICONS.proteinAll);
          html += '<button type="button" class="chip ' + (sel ? 'sel' : '') + '" data-prot="' + p.id + '"><span class="img-slot img-slot-chip">' + ic + '</span>' + esc(p.name) + '</button>';
        });
        html += '</div><div class="inline-nav"><button type="button" class="back-btn" data-nav="back">← Back</button><button type="button" class="continue-btn" data-nav="next">Continue</button></div>';
      } else if (step === 7) {
        var selectedAll = ALLERGENS.filter(function (a) { return state.allergens[a]; });
        html += '<div class="step-head"><div class="num-badge">7</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="chip-row">';
        ALLERGENS.forEach(function (a) {
          var allergenIconUrl = ALLERGEN_ICONS[a] || '';
          var ic = allergenIconUrl
            ? '<img class="mpw-allergen-icon" src="' + esc(allergenIconUrl) + '" alt="" width="24" height="24">'
            : (a === 'Fish' ? ICONS.FishA : (a === 'Pork' ? ICONS.pork : (ICONS[a] || ICONS.Egg)));
          html += '<button type="button" class="chip ' + (state.allergens[a] ? 'sel' : '') + '" data-all="' + esc(a) + '"><span class="img-slot img-slot-chip">' + ic + '</span>' + esc(a) + '</button>';
        });
        html += '</div><div class="chip-status">' + (selectedAll.length ? ('Excluding: ' + esc(selectedAll.join(', '))) : 'No exclusions selected.') + '</div>';
        html += '<div class="inline-nav"><button type="button" class="back-btn" data-nav="back">← Back</button><button type="button" class="continue-btn" data-nav="next">Continue</button></div>';
      } else if (step === 8) {
        html += '<div class="step-head"><div class="num-badge">8</div><div class="step-copy"><h1 class="hd step-title">Sign up to receive <span style="color:var(--red)">exclusive offers</span></h1><p class="step-sub">' + esc(def.sub) + '</p></div></div>';
        html += '<div class="promo-callout"><div class="promo-icon" aria-hidden="true"><svg viewBox="0 0 32 32" width="20" height="20" fill="none"><rect x="5" y="8" width="22" height="16" rx="2.5" stroke="currentColor" stroke-width="2.8"/><path d="m7 10 9 7 9-7" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg></div><div class="promo-body"><div class="promo-row"><input class="promo-input" type="email" aria-label="Email address" autocomplete="email" placeholder="you@example.com" value="' + esc(state.promoEmail) + '"' + (state.promoBusy ? ' disabled' : '') + '></div>';
        html += '<label class="promo-consent-row"><button type="button" class="checkbox ' + (state.promoConsent ? 'on' : '') + '" data-toggle="consent" role="checkbox" aria-checked="' + !!state.promoConsent + '" aria-label="I agree to receive marketing emails"' + (state.promoBusy ? ' disabled' : '') + '></button><span class="promo-consent-text" style="color:#C9CBD0">By entering my email, I agree to receive marketing emails from UFC Ignite and accept the Privacy Policy. I can unsubscribe anytime.</span></label>';
        if (state.promoError) html += '<p role="alert" style="margin:12px 0 0;color:#ff5a63;font-size:14px">' + esc(state.promoError) + '</p>';
        html += '</div></div>';
        html += '<div class="inline-nav"><button type="button" class="back-btn" data-nav="back"' + (state.promoBusy ? ' disabled' : '') + '>← Back</button><div style="display:flex;gap:12px"><button type="button" class="ghost-btn" data-nav="skip8"' + (state.promoBusy ? ' disabled' : '') + '>Skip</button><button type="button" class="continue-btn" data-nav="next"' + (state.promoBusy ? ' disabled' : '') + '>' + (state.promoBusy ? 'Submitting...' : 'Continue') + '</button></div></div>';
      } else if (step === 9) {
        var filtered = filteredMeals();
        var actP = activeProteins();
        var hasPref = actP.length > 0;
        var recommended = hasPref
          ? filtered.filter(function (m) { return mealMatchesProteins(m, actP); })
          : filtered;
        var otherMeals = hasPref
          ? filtered.filter(function (m) { return !mealMatchesProteins(m, actP); })
          : [];
        var otherVisible = state.otherMealsExpanded
          ? otherMeals
          : otherMeals.slice(0, OTHER_MEALS_INITIAL);
        var otherRemaining = Math.max(0, otherMeals.length - OTHER_MEALS_INITIAL);
        var totalQty = sumQty(state.mealQty);
        var remain = Math.max(0, state.boxSize - totalQty);
        html += '<div class="step-head"><div class="num-badge">9</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div>';
        html += '<div class="meals-head"><div class="meals-head-actions"><button type="button" class="smart-btn" data-toggle="smart">Smart selection — add recommended</button><button type="button" class="clear-btn" data-toggle="clear">Clear selection</button></div>';
        html += '<div class="sel-pill ' + (totalQty === state.boxSize ? 'pill-ok' : 'pill-warn') + '">' + totalQty + '/' + state.boxSize + ' Selected</div></div>';
        if (remain) html += '<p class="meals-hint">Add ' + remain + ' more meal(s) to complete your box.</p>';
        if (hasPref) html += '<div class="group-label">Recommended</div>';
        if (!recommended.length) {
          html += '<p class="meals-hint">' + (hasPref
            ? 'No meals match your protein preference on this plan. Browse Other Meals below, or go back to change preferences / plan.'
            : 'No meals available for this plan with your exclusion filters.') + '</p>';
        } else {
          html += '<div class="meal-grid">' + recommended.map(function (m, i) { return renderMealCard(m, i, totalQty); }).join('') + '</div>';
        }
        if (otherMeals.length) {
          html += '<div class="other-meals">';
          html += '<div class="group-label">Other Meals</div>';
          html += '<p class="meals-hint other-meals-sub">These meals are outside your protein filters. You can still add them to your box.</p>';
          html += '<div class="meal-grid">' + otherVisible.map(function (m, i) { return renderMealCard(m, i, totalQty); }).join('') + '</div>';
          if (!state.otherMealsExpanded && otherRemaining > 0) {
            html += '<div class="meals-load-more-wrap"><button type="button" class="meals-load-more-btn" data-toggle="load-other">Load more (' + otherRemaining + ' meals)</button></div>';
          }
          html += '</div>';
        }
      } else if (step === 10) {
        var price = boxPriceCents();
        var firstPct = Number(config.firstOrderPct || 25);
        var secondPct = Number(config.secondOrderPct || 15);
        var thirdPct = Number(config.thirdOrderPct || 10);
        var p1 = Math.round(price * (1 - firstPct / 100));
        var p2 = Math.round(price * (1 - secondPct / 100));
        var p3 = Math.round(price * (1 - thirdPct / 100));
        html += '<div class="step-head"><div class="num-badge">10</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div><div class="plan-stack">';
        html += '<div class="plan-card plan-card-sub ' + (state.plan === 'subscribe' ? 'sel' : '') + '" data-plan="subscribe" role="button" tabindex="0"><div class="plan-tag">Recommended</div><div class="plan-title-lg"><div class="radio ' + (state.plan === 'subscribe' ? 'sel' : '') + '"></div>Subscribe &amp; Save</div><div class="plan-desc">Skip, pause, or cancel anytime.</div>';
        html += '<div class="tier-row"><div class="tier-hero"><div class="tier-hero-badge">You start here</div><div class="hd tier-hero-pct">' + firstPct + '<span>% OFF</span></div><div class="tier-hero-week">Week 1</div><div class="tier-hero-price"><span class="tier-price-strike">' + money(price) + '</span><span class="tier-price-now">' + money(p1) + '</span></div></div>';
        html += '<div class="tier-mini-col"><div class="tier-mini"><div class="tier-mini-dot"></div><div class="tier-mini-body"><div class="tier-mini-week">Week 2</div><div class="tier-mini-pct">' + secondPct + '% off</div></div><div class="tier-mini-price"><span class="tier-price-strike">' + money(price) + '</span><span class="tier-price-now">' + money(p2) + '</span></div></div>';
        html += '<div class="tier-mini"><div class="tier-mini-dot"></div><div class="tier-mini-body"><div class="tier-mini-week">Week 3</div><div class="tier-mini-pct">' + thirdPct + '% off</div></div><div class="tier-mini-price"><span class="tier-price-strike">' + money(price) + '</span><span class="tier-price-now">' + money(p3) + '</span></div></div></div></div>';
        if (config.showGovxVerify !== false && config.govxVerifyUrl) {
          html += '<a class="mpw-govx-verify" href="' + esc(config.govxVerifyUrl) + '" target="_blank" rel="noopener noreferrer"><span class="mpw-govx-verify__icon"><img src="https://i4.govx.net/images/cdn/govxid-new-logo-shopify-iapp-icon.jpg" alt="" width="40" height="40" loading="lazy"></span><span class="mpw-govx-verify__text">Military, veterans &amp; first responders — <span class="mpw-govx-verify__accent">Verify for discount</span></span></a>';
        }
        html += '</div>';
        html += '<button type="button" class="plan-card plan-card-sm ' + (state.plan === 'onetime' ? 'sel' : '') + '" data-plan="onetime"><div class="plan-title-sm"><div class="radio ' + (state.plan === 'onetime' ? 'sel' : '') + '"></div>One-Time Purchase<span class="plan-onetime-price">' + money(price) + '</span></div><div class="plan-desc-sm">Order this box once at full price. No recurring charges, no commitment.</div></button></div>';
        html += '<p class="fine-print" style="font-size:12px">* Box price without shipping &amp; handling fee</p>';
      } else if (step === 11) {
        var gdef = GOAL_DEFS.find(function (x) { return x.id === state.goal; });
        var price2 = boxPriceCents();
        var isSub = state.plan === 'subscribe';
        var firstOrderPct = Number(config.firstOrderPct || 25);
        var savings = isSub ? Math.round(price2 * firstOrderPct / 100) : 0;
        var shipping = Number((config.shipping || {})[String(state.boxSize)]);
        var shippingKnown = Number.isFinite(shipping) && shipping >= 0;
        var total = price2 - savings + (shippingKnown ? shipping : 0);
        var avoidList = ALLERGENS.filter(function (a) { return state.allergens[a]; });
        var actP2 = activeProteins();
        var byId = {};
        catalogForPlan().forEach(function (m) { byId[m.id] = m; });
        html += '<div class="step-head"><div class="num-badge">11</div><div class="step-copy"><h1 class="hd step-title">' + esc(def.title) + '</h1><p class="step-sub">' + esc(def.sub) + '</p></div></div>';
        html += '<div class="summary-card">';
        html += '<div class="summary-row"><span class="summary-k">Goal</span><span class="summary-v">' + esc(gdef ? gdef.name : '') + '</span></div>';
        html += '<div class="summary-row"><span class="summary-k">Weekly box</span><span class="summary-v">' + state.boxSize + ' meals — ' + esc(effectivePlanType()) + '</span></div>';
        html += '<div class="summary-row"><span class="summary-k">Exclusions</span><span class="summary-v">' + esc(avoidList.length ? avoidList.join(', ') : 'None') + '</span></div>';
        html += '<div class="summary-row"><span class="summary-k">Protein preference</span><span class="summary-v">' + esc(actP2.length ? actP2.map(function (id) { var p = PROTEINS.find(function (x) { return x.id === id; }); return p ? p.name : id; }).join(', ') : 'All') + '</span></div>';
        html += '<div class="summary-row"><span class="summary-k">Plan type</span><span class="summary-v">' + (isSub ? 'Subscribe' : 'One-Time') + '</span></div>';
        html += '<div class="summary-row"><span class="summary-k">Est. delivery</span><span class="summary-v">' + esc(deliveryDateLabel()) + '</span></div></div>';
        var reviewRows = [];
        Object.keys(state.mealQty).forEach(function (pid) {
          var m = byId[pid];
          if (!m) return;
          reviewRows.push({ meal: m, qty: state.mealQty[pid] });
        });
        var reviewVisible = state.reviewMealsExpanded
          ? reviewRows
          : reviewRows.slice(0, REVIEW_MEALS_INITIAL);
        var reviewRemaining = Math.max(0, reviewRows.length - REVIEW_MEALS_INITIAL);
        html += '<div class="meal-recap">';
        reviewVisible.forEach(function (row) {
          html += '<div class="meal-recap-row"><div class="meal-recap-thumb"' + (row.meal.img ? ' style="background-image:url(' + esc(row.meal.img) + ');background-size:cover"' : '') + '></div><span class="meal-recap-name">' + esc(row.meal.name) + '</span><b>×' + row.qty + '</b></div>';
        });
        html += '</div>';
        if (!state.reviewMealsExpanded && reviewRemaining > 0) {
          html += '<div class="meals-load-more-wrap meal-recap-load-more"><button type="button" class="meals-load-more-btn" data-toggle="load-review">Load more (' + reviewRemaining + ' meals)</button></div>';
        }
        html += '<div class="totals"><div class="total-row"><span>Weekly box total</span><span>' + money(price2) + '</span></div>';
        if (isSub && savings) html += '<div class="total-row" style="color:#2fae5c"><span>Week 1 savings (' + firstOrderPct + '% off)</span><span>−' + money(savings) + '</span></div>';
        html += '<div class="total-row"><span>Shipping &amp; handling</span><span>' + (shippingKnown ? money(shipping) : 'Calculated at checkout') + '</span></div>';
        html += '<div class="total-row accent"><span>' + (shippingKnown ? 'Estimated total' : 'Subtotal') + '</span><span>' + money(total) + '</span></div></div>';
        html += '<p class="fine-print">' + (shippingKnown ? 'Includes shipping &amp; handling for this box. ' : '') + 'Taxes and any checkout discounts are calculated at checkout. Final total confirmed at checkout.</p>';
        if (isSub) {
          html += '<div class="terms-row"><button type="button" class="checkbox ' + (state.terms ? 'on' : '') + '" data-toggle="terms"></button><p class="legal-text">By clicking “Checkout,” you are starting a recurring UFC Ignite weekly subscription. You authorize UFC Ignite to charge your payment method the amount shown in your “Weekly Box Total” (plus any fees for shipping &amp; handling) each week while your subscription is active. You can pause or cancel your subscription anytime in My Account. The weekly deadline to pause or cancel your subscription to avoid weekly charges is Monday at 11:59pm PT.</p></div>';
        }
        html += '<p class="checkout-coupon-note">Coupon codes can be entered during the payment step on the next screen.</p>';
        var orderDisabled = (isSub && !state.terms) || state.checkoutBusy || sumQty(state.mealQty) !== state.boxSize;
        html += '<button type="button" class="order-btn" data-nav="checkout"' + (orderDisabled ? ' disabled' : '') + '>' + (state.checkoutBusy ? 'Working…' : 'Go Checkout') + '</button>';
      }

      html += '</main>';
      if (step === 9 || step === 10) {
        var can = step === 9 ? sumQty(state.mealQty) === state.boxSize : !!state.plan;
        html += '<div class="botnav"><div class="botnav-inner"><button type="button" class="back-btn" data-nav="back">← Back</button><button type="button" class="continue-btn" data-nav="next"' + (can ? '' : ' disabled') + '>Continue</button></div></div>';
      } else if ((step >= 1 && step <= 4) || step === 11) {
        html += '<div class="botnav"><div class="botnav-inner"><button type="button" class="back-btn" data-nav="back"' + (step === 1 ? ' style="visibility:hidden"' : '') + '>← Back</button><div></div></div></div>';
      }
      if (state.promoModalOpen) {
        var confirmedEmail = String(state.promoEmail || '').trim();
        html += '<div class="mpw-email-modal" data-email-modal>';
        html += '<div class="mpw-email-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="mpw-email-modal-title" aria-describedby="mpw-email-modal-copy" tabindex="-1">';
        html += '<div class="mpw-email-modal__icon" aria-hidden="true"><svg viewBox="0 0 32 32" fill="none"><rect x="5" y="8" width="22" height="16" rx="2.5" stroke="currentColor" stroke-width="2.8"/><path d="m7 10 9 7 9-7" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
        html += '<h2 class="hd mpw-email-modal__title" id="mpw-email-modal-title">Check your inbox</h2>';
        html += '<p class="mpw-email-modal__copy" id="mpw-email-modal-copy">We\'ve sent your promo code to <strong>' + esc(confirmedEmail) + '</strong>. Make sure to check your promotion and spam folder if you do not see it. You can enter the code at checkout.</p>';
        html += '<button type="button" class="mpw-email-modal__continue" data-nav="promo-confirm">Continue</button>';
        html += '</div></div>';
      }
      html += '</div>';
      mount.innerHTML = html;
      document.body.classList.toggle('mpw-email-modal-open', !!state.promoModalOpen);
      if (state.promoModalOpen) {
        var modal = mount.querySelector('.mpw-email-modal');
        var app = modal && modal.parentElement;
        if (app) {
          Array.prototype.forEach.call(app.children, function (child) {
            if (child === modal) return;
            child.inert = true;
            child.setAttribute('aria-hidden', 'true');
          });
        }
        requestAnimationFrame(function () {
          var button = mount.querySelector('.mpw-email-modal__continue');
          if (button) button.focus();
        });
      } else if (promoReturnFocus) {
        promoReturnFocus = false;
        requestAnimationFrame(function () {
          var trigger = mount.querySelector('[data-nav="next"]');
          if (trigger) trigger.focus();
        });
      }
    }

    trackQuiz(restored ? 'quiz_resumed' : 'quiz_started', { entry_type: restored ? 'resumed' : shoppingPreselection ? 'shopping' : hashGoal ? 'goal_link' : 'direct' });
    bind();
    saveWizardState(state);
    render();
    window.addEventListener('pagehide', function () { saveWizardState(state); });
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      var again = loadWizardState();
      if (!again) return;
      Object.keys(again).forEach(function (k) { state[k] = again[k]; });
      state.checkoutBusy = false;
      render();
    });
    window.UFC_MPW = { computeBoxSize: computeBoxSize, state: state, clearWizardState: clearWizardState };
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
